import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import DownloadMaterialButton from '../DownloadMaterialButton';

import { minDesktop } from '../styles/breakpoints';
import { ListStyleSymbolFont, HeadlineFont } from '../styles/fonts';

import H2 from '../H2';

const DESCRIPTIONS = [
  'Einf&uuml;hrung in das Thema',
  'Lernziele',
  'Hintergrundinformationen',
  'Didaktische Grundlagen',
  'Lehrplananbindung',
];

const UL = styled.ul`
  padding: 0;
  padding-bottom: 5px;
`;

const LI = styled.li`
  font-size: 20px;
  line-height: 1.2;
  list-style-type: none;

  &:before {
    ${ListStyleSymbolFont};
    content: '\u2192';
    margin-right: 0.5em;
    margin-left: 0.1em;

    font-size: 24px;
    ${minDesktop} {
      font-size: 32px;
    }
  }

  ${minDesktop} {
    font-size: 22px;
  }
`;

const Article = styled.article`
  margin-top: 20px;
  padding-bottom: 50px;
`;

const DownloadContainer = styled.div``;

const DownloadMaterialButtonStyled = styled(DownloadMaterialButton)`
  padding: 10px .5em 10px 0;
  border-radius: 3px;
`;

const H2Styled = styled(H2)`
  ${HeadlineFont};
`;

const MaterialDescription = ({ className }) => (
  <Article className={className}>
    <H2Styled>
      Einleitung (PDF)
    </H2Styled>
    <UL>
      { DESCRIPTIONS.map(text => (
        <LI key={text} dangerouslySetInnerHTML={{ __html: text }} />
      ))}
    </UL>
    <DownloadContainer>
      <DownloadMaterialButtonStyled label="Einleitung herunterladen" download="ModeBewusst_Einleitung.pdf" href="/downloads/ModeBewusst_Einleitung.pdf" />
    </DownloadContainer>
  </Article>
);

MaterialDescription.propTypes = {
  className: PropTypes.string,
};

MaterialDescription.defaultProps = {
  className: undefined,
};

export default MaterialDescription;



// WEBPACK FOOTER //
// ./src/components/AboutMaterialDownload/MaterialDescription.js